module.exports = __webpack_public_path__ + "img/home-4-line.a5430e9a.svg";